(function () {
  'use strict';

  if (window.PesadoUpgradeAnalytics) return;

  var SESSION_KEY = 'pesado_upgrade_session_v1';
  var CART_SIGNATURE_KEY = 'pesado_cart_attribution_written_v1';
  var UPGRADE_VERSION = '2026-07-22';
  var context = window.PesadoThemeContext || {};
  var previewEvents = [];

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'psd-' + window.crypto.randomUUID();
    }
    return 'psd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function persistentId() {
    try {
      var existing = localStorage.getItem(SESSION_KEY);
      if (existing) return existing;
      var previous = sessionStorage.getItem(SESSION_KEY) || randomId();
      localStorage.setItem(SESSION_KEY, previous);
      return previous;
    } catch (error) {
      return randomId();
    }
  }

  function currentCurrency() {
    var visible = document.querySelector('[data-currency-wrap] [data-current]');
    if (visible && visible.textContent) return visible.textContent.trim().toUpperCase();
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active.toUpperCase();
    try {
      if (window.T4SThemeSP && typeof T4SThemeSP.storageCurrency === 'function') {
        var fromTheme = T4SThemeSP.storageCurrency();
        if (fromTheme) return String(fromTheme).toUpperCase();
      }
      return (localStorage.getItem('T4Currency') || '').toUpperCase();
    } catch (error) {
      return '';
    }
  }

  function route(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  var attributionId = persistentId();
  var environment = context.environment === 'production' ? 'production' : 'preview';

  function payload(action, data) {
    return Object.assign({
      action: action,
      attribution_id: attributionId,
      environment: environment,
      theme_id: context.themeId || '',
      page_path: window.location.pathname,
      currency: currentCurrency(),
      timestamp: new Date().toISOString()
    }, data || {});
  }

  function track(action, data) {
    var eventPayload = payload(action, data);
    if (environment === 'preview') previewEvents.push(eventPayload);
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('pesado_upgrade', eventPayload);
      }
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('pesado:analytics', { detail: eventPayload }));
    return eventPayload;
  }

  function lineProperties(source, data) {
    data = data || {};
    return {
      _pesado_source: source || 'unknown',
      _pesado_attribution_id: attributionId,
      _pesado_environment: environment,
      _pesado_machine: data.machine || '',
      _pesado_parent_product: data.parentProduct || '',
      _pesado_recommendation_rank: data.rank || '',
      _pesado_recommendation_reason: data.reason || '',
      _pesado_target_tier: data.targetTier || '',
      _pesado_gap_before: data.gapBefore || ''
    };
  }

  function ensureCartAttribution() {
    var signature = attributionId + '|' + environment + '|' + (context.themeId || '');
    try {
      if (sessionStorage.getItem(CART_SIGNATURE_KEY) === signature) return Promise.resolve();
    } catch (error) {}

    return fetch(route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: {
        __pesado_attribution_id: attributionId,
        __pesado_environment: environment,
        __pesado_theme_id: context.themeId || '',
        __pesado_upgrade_version: UPGRADE_VERSION
      } })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to persist Pesado attribution');
      try { sessionStorage.setItem(CART_SIGNATURE_KEY, signature); } catch (error) {}
    }).catch(function () {});
  }

  window.PesadoUpgradeAnalytics = {
    sessionId: attributionId,
    environment: environment,
    themeId: context.themeId || '',
    previewEvents: previewEvents,
    track: track,
    lineProperties: lineProperties,
    ensureCartAttribution: ensureCartAttribution
  };
})();
